import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import Chat from '../shared/chat/floating';
import { useLoggedUser } from '@/hooks/user/useLoggedUser';

const Layout: React.FC = () => {
  const { userType } = useLoggedUser();
  return (
    <div className="flex">
      <Sidebar />

      <div className="flex flex-col flex-1 ms-[250px]">
        <Header />
        <main className="bg-dashboard w-full min-h-screen relative mt-[63px]">
          {userType !== 'ADMIN' && <Chat />}
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;
